// polyfill ES2015 features like Symbol for browser like IE
import '@babel/polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// This would be check which env is running on.
// For Node.js, global variable is "global".
// But for browser, global variable is "window".
if (typeof window === 'undefined') {
  global.Promise = require('bluebird')
} else {
  window.Promise = require('bluebird')
}

// fetch() polyfill for making API calls.
require('whatwg-fetch')



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 2577
// module chunks = 13